import m, {Vnode, VnodeDOM} from "mithril";
import CustomForm from "../CustomForm";
import {ValidationError} from "../ICustomForm";
import ICustomFormSettings from "../ICustomFormSettings";
import h from "../../ui/design";
import CheckboxCell from "../shared/components/FormCell/CheckboxCell";
import {CheckboxItem} from "../../model/items/checkbox";
import {TextareaItem} from "../../model/items/textarea";
import TextareaCell from "../shared/components/FormCell/TextareaCell";

export default abstract class Text extends CustomForm {

    private errorMessage: string|null = null;

    protected readonly checkboxes: CheckboxCell[] = [];
    protected textareaCell!: TextareaCell;

    constructor(settings: ICustomFormSettings) {
        super(settings);

        for (const cell of settings.form.grid.cells) {
            for (const cellItem of cell.cellItems) {
               if (cellItem instanceof CheckboxItem) {
                    this.checkboxes.push(new CheckboxCell(
                        cell,
                        this.onSetValue.bind(this),
                    ));
                } else if (!this.textareaCell && cellItem instanceof TextareaItem) {
                    this.textareaCell = new TextareaCell(cellItem);
                }
            }
        }

    }

    public onValidationErrors(errors: ValidationError[]): void {
        this.errorMessage = this.settings.app.messages.get('validateMessage');
    }

    public rewriteFormControls(): boolean {
        return true;
    }

    checkRequirements(): boolean {
        const form = this.settings.form;

        if (!form.text) {
            console.log('customForm-Text-default: missing question text');
            return false;
        }

        if (!this.textareaCell) {
            console.log('customForm-Text-default: missing textarea');
            return false;
        }


        return true;
    }

    public view(): Vnode {

        return m(".customForm", {}, [
            m(this.settings.app.header),
            m("div", {
                "class": this.settings.formHtmlClass(),
            }, [
                m(".content", {}, [
                    m(this.validateBox),
                    this.viewHeroVideo(),
                    this.viewHeroImage(),
                    this.viewTextPart(),
                    this.errorMessage ? m("div.error-alert", this.errorMessage) : null,
                    m('.', {}, this.checkboxes.map(cell => m(cell))),
                ]),
                this.viewControls(),
            ]),

        ]);
    }

    public viewTextPart(): Vnode {
        return m("form", {}, m(this.textareaCell));
    }

    public oncreate(vnode: VnodeDOM): void {
        super.oncreate(vnode);

        const $textarea = $(vnode.dom).find('textarea');

        if (window.innerWidth >= h.BC.md) {
            setTimeout(() => {$textarea.focus();}, 50);
        }
    }
}